import React, { Fragment } from "react";
import { Button, Modal } from "react-bootstrap";
import CookieConsent from "react-cookie-consent";
import MetaTags from "react-meta-tags";
import CodingContainer from "../../components/info-containers/CodingContainer";
import RoboticsContainer from "../../components/info-containers/RoboticsContainer";
import TechnologyContainer from "../../components/info-containers/TechnologyContainer";
import VideoPopupTwo from "../../components/video-popup/VideoPopupTwo";
import LayoutOne from "../../layouts/LayoutOne";
import FeatureIconThree from "../../wrappers/feature-icon/FeatureIconThree";
import FunFactOne from "../../wrappers/fun-fact/FunFactOne";
import HeroSlider from "../../wrappers/hero-slider/HeroSlider";
import { LocationDialog } from "./components/LocationDialog";
import AsSeenInSliderOne from "../../wrappers/brand-logo/AsSeenInSliderOne";
import AnnouncementsContainer from "../../components/announcements/AnnouncementsContainer";

const ZebraHomePage = () => {
  return (
    <Fragment>
      <MetaTags>
        <title>Zebra Robotics</title>
        <meta name="description" content="Coding and Robotics classes." />
      </MetaTags>
      <LayoutOne
        headerContainerClass="container-fluid"
        headerPaddingClass="header-padding-2"
      >
        {/* hero slider */}
        <HeroSlider />
        {/* fun fact */}
        <FunFactOne
          spaceTopClass="pt-100"
          spaceBottomClass="pb-70"
          bgClass="bg-gray-3"
        />
        {/* video popup */}
        <VideoPopupTwo spaceBottomClass="pb-100" />
        {/* Announcements */}
        <AnnouncementsContainer spaceBottomClass="pb-85" />
        {/* feature icon */}
        <FeatureIconThree
          spaceBottomClass="pb-20"
          featureShapeClass="support-shape-3"
        />
        <CodingContainer
          spaceBottomClass="pb-20"
          img="/assets/zebra_images/roadmaps/coding_roadmap.png"
        />
        <RoboticsContainer
          spaceBottomClass="pb-20"
          img="/assets/zebra_images/roadmaps/robotics_roadmap.png"
        />
        <TechnologyContainer
        spaceBottomClass="pb-70"
        img="/assets/zebra_images/roadmaps/technology_roadmap.png"
      />
        <AsSeenInSliderOne spaceBottomClass="pb-35" spaceTopClass="pt-10" />
      </LayoutOne>
    </Fragment>
  );
};

export default ZebraHomePage;
